<app-advanced-search
  [isForAddToCatalogue]="true"
  (addToCatalogue)="handleAddToCatalogue($event)"
></app-advanced-search>
